export const breakpoints = {
  mobile: '768px',
  table: '1024px',
  desktop: '1368px',
};
